import { b as base } from "../../../../chunks/server.js";
import "../../../../chunks/url.js";
import "@sveltejs/kit/internal/server";
import "../../../../chunks/root.js";
import { g as getOAuthConfig, i as generateCodeVerifier, j as generateCodeChallenge, k as generateState, a as getCallbackUrl, c as cookieOptions, s as sanitizeOAuthReturnPath, h as OAUTH_RETURN_COOKIE, l as buildAuthorizationUrl } from "../../../../chunks/oauth.js";
import { redirect } from "@sveltejs/kit";
const GET = async ({ url, cookies }) => {
  const config = await getOAuthConfig();
  if (!config) {
    redirect(302, `${base}/`);
  }
  const codeVerifier = generateCodeVerifier();
  const codeChallenge = generateCodeChallenge(codeVerifier);
  const state = generateState();
  const callbackUrl = getCallbackUrl(url.origin);
  cookies.set("mongoku_pkce_verifier", codeVerifier, cookieOptions(url, 300));
  cookies.set("mongoku_pkce_state", state, cookieOptions(url, 300));
  const returnParam = url.searchParams.get("return");
  const sanitizedReturn = sanitizeOAuthReturnPath(url, returnParam);
  if (sanitizedReturn) {
    cookies.set(OAUTH_RETURN_COOKIE, sanitizedReturn, cookieOptions(url, 300));
  } else {
    cookies.delete(OAUTH_RETURN_COOKIE, cookieOptions(url));
  }
  redirect(302, buildAuthorizationUrl(config, url.origin, callbackUrl, codeChallenge, state));
};
export {
  GET
};
